import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  ancillaryEndorsement: {
    description: 'Other Shipping Options - DHL eComm - Ancillary Endorsement',
    defaultMessage: 'Ancillary Endorsement',
    id: '5JTLaG',
  },
  endorsementNone: {
    description: 'Other Shipping Options - DHL eComm - Ancillary Endorsement - None',
    defaultMessage: 'None',
    id: 'h+ijOz',
  },
  endorsementAddressServiceRequested: {
    description: 'Other Shipping Options - DHL eComm - Ancillary Endorsement - Address Service Requested',
    defaultMessage: 'Address Service Requested',
    id: 'o/ddHd',
  },
  endorsementForwardingServiceRequested: {
    description: 'Other Shipping Options - DHL eComm - Ancillary Endorsement - Forwarding Service Requested',
    defaultMessage: 'Forwarding Service Requested',
    id: 'sq7L8+',
  },
  endorsementChangeServiceRequested: {
    description: 'Other Shipping Options - DHL eComm - Ancillary Endorsement - Change Service Requested',
    defaultMessage: 'Change Service Requested',
    id: 'WrRzTk',
  },
  endorsementReturnServiceRequested: {
    description: 'Other Shipping Options - DHL eComm - Ancillary Endorsement - Return Service Requested',
    defaultMessage: 'Return Service Requested',
    id: 'v6j4Cy',
  },
  selectAncillaryEndorsement: {
    description: 'Other Shipping Options - DHL eComm - Ancillary Endorsement - Select Ancillary Endorsement',
    defaultMessage: 'Select Ancillary Endorsement',
    id: '5pL5uY',
  },
});
